import Swal from 'sweetalert2';

export const CustomSwal = Swal.mixin({
  customClass: {
    popup: 'my-swal-popup',
    title: 'my-swal-title',
    htmlContainer: 'my-swal-text',
    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button'
  },
  buttonsStyling: false
});

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in|edu)$/i;
  return emailRegex.test(email);
};

export const isValidMobile = (mobile: string): boolean => {
  return /^\d{10}$/.test(mobile);
};

// export const maskEmail = (email: string): string => {
//   if (!email || !email.includes('@')) return email;
//   const [name, domain] = email.split('@');
//   const firstPart = name.slice(0, 4);
//   const lastPart = domain.slice(-5);
//   return `${firstPart}***@***${lastPart}`;
// };

export const maskEmail = (email: string): string => {
  if (!email) return "";
  const [localPart, domain] = email.split("@");
  if (localPart.length <= 4) {
    return localPart.replace(/./g, "*") + "@" + domain;
  }
  return localPart.slice(0, 4) + "********@" + domain;
};

export const maskMobile = (mobile: string): string => {
  if (!mobile) return "";
  if (mobile.length <= 4) {
    return mobile.replace(/./g, "*");
  }
  return "******" + mobile.slice(-4);
};


export const showOtpPrompt = async (mobile?: string, email?: string) => {
  const label = () => {
    if (mobile) return `OTP sent to ${maskMobile(mobile)}`;
    if (email) return `OTP sent to ${maskEmail(email)}`;
    return `OTP sent`;
  };


  const { value: enteredOTP } = await CustomSwal.fire({
    title: 'Enter OTP',
    input: 'text',
    inputLabel: label(),
    inputPlaceholder: 'Enter your OTP',
    showCancelButton: true,
    confirmButtonText: 'Verify OTP',
    cancelButtonText: 'Cancel',
    allowOutsideClick: false,
    allowEscapeKey: false,
    preConfirm: (otp) => {
      if (!otp) {
        CustomSwal.showValidationMessage('Please enter OTP');
        return false;
      }
      return otp;
    }
  });

  return enteredOTP;
};